import React, { useContext, useState } from "react";
import RegistrationContext from "../contexts/RegistrationContext";
import axios from "axios";
import { base_url } from "../config";

const Disclaimer = () => {
  const { setError, reload, setReload, disclaimerAccepted } =
    useContext(RegistrationContext);

  const [disclaimerChecked, setDisclaimerChecked] =
    useState(disclaimerAccepted);

  const handleSelect = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${base_url}/api/disclaimer`, {
        disclaimer_accepted: disclaimerChecked,
      });
      if (response.status === 200) {
        setReload(reload + 1);
      }
    } catch (error) {
      setError(
        "Unexpected error. " + error.response?.data?.message || "Unknown error"
      );
    }
  };

  return (
    <>
      <div className="container mx-auto px-4 py-8  flex flex-col overflow-y-scroll h-full">
        <div className="bg-white rounded-xl shadow-lg flex flex-col flex-1 py-6">
          <h2 className="text-2xl font-bold text-gray-800 text-center">
            GENERAL DISCLAIMER
          </h2>

          {/* Scrollable Content */}
          <div className="flex-1 overflow-y-scroll px-8 space-y-6">
            <section>
              <h3 className="text-lg font-semibold text-gray-700">
                Cancellation and Changes
              </h3>
              <p className="text-gray-600">
                All cancellations must be sent to{" "}
                <strong>registration@ijcai.org</strong> via e-mail. Any change
                of name will be dealt with as a cancellation and a new
                registration. <strong>Students</strong> applying to
                IJCAI-ECAI-26 Volunteering Program MUST NOT register before
                notification from Volunteers’ Chair, otherwise the processing
                fee of U$ 150 shall apply.
              </p>
              <p className="text-gray-600">
                In case of cancellations until July 15, 2026, payments will be
                refunded less U$ 150 processing fee. The processing fee of U$
                150 shall apply to any and all cancellations!{" "}
              </p>
              <p className="text-gray-600">
                No refund will be made for cancellations received after July 15,
                2026 or to the registrants who fail to attend in person.{" "}
              </p>
              <p className="text-gray-600">
                In case of conference cancellation for reasons beyond the
                control of IJCAI-ECAI-26 organizers, the liability of the
                IJCAI-ECAI-26 organizers is limited to the fees already paid by
                the registrants. IJCAI-ECAI-26 organizers will not be
                responsible for any personal inconvenience that may arise.{" "}
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-700">
                General Disclaimer for Service Providers
              </h3>
              <p className="text-gray-600">
                In offering the Bremen Airport, Airport public transportation
                system, Bremen public transportation system, the Messe Bremen,
                Conventus Congressmanagement & Marketing GmbH, and all other
                service providers (hereinafter referred to as “Supplier(s)”)
                for the IJCAI-ECAI-26, the IJCAI-ECAI-26 organizers act only in
                the capacity of agent for the Suppliers and have no control
                over personnel, equipment or operations or providers of
                accommodations or other services included as part of the
                IJCAI-ECAI-26 program. The IJCAI-ECAI-26 organizers assume no
                responsibility for and will not be liable for any personal
                delay, inconvenience or other damage suffered by conference
                participants which may arise by reason of (1) any wrongful or
                negligent acts or omissions on the part of any Supplier or its
                employees, (2) any defect in or failure of any vehicle,
                equipment or instrumentality owned, operated or otherwise used
                by any Supplier, or (3) any wrongful or negligent acts or
                omissions on the part of any other party not under control,
                direct or otherwise, of the IJCAI-ECAI-26 organizers.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-700">
                Information Processing
              </h3>
              <p className="text-gray-600">
                The processing of personal data, such as the name, address,
                e-mail address, affiliation and payment information of a data
                subject shall always be in line with the General Data Protection
                Regulation (GDPR), and in accordance with the country-specific
                data protection regulations applicable to the IJCAI
                Organization.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-700">
                Cancellation Policy and Registration Information
              </h3>
              <p className="text-gray-600">
                I confirm that I have read, understood and agree to all
                information pertaining to registration, cancellation, fees and
                other policies as stipulated under{" "}
                <a
                  href="https://2026.ijcai.org/registration"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline"
                >
                  https://2026.ijcai.org/registration
                </a>{" "}
                by proceeding to complete my registration.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-700">
                Photograph and Video Release
              </h3>
              <p className="text-gray-600">
                For valuable consideration received, I hereby give the
                International Joint Conferences on Artificial Intelligence
                Organization (IJCAI) the absolute and irrevocable right and
                permission, with respect to the photographs and film or tape
                that it will take of me during the 35th International Joint
                Conference on Artificial Intelligence (IJCAI-ECAI-26) held
                August 15-21, 2026 at the University of Bremen,
                Bibliothekstraße 1, 28359 Bremen, Germany and Messe Bremen,
                Findorffstr. 101, 28215 Bremen, Germany.
              </p>
              <p className="text-gray-600">
                (1) To copyright the same in its own name or any other name that
                it may choose.
              </p>
              <p className="text-gray-600">
                (2) To use, re-use, publish, and re-publish the same in whole or
                in part, individually or in conjunction with other photographs
                or images or video recordings, in any medium and for any
                purpose whatsoever, including (but not by way of limitation)
                illustration, promotion, advertising and trade, and
              </p>
              <p className="text-gray-600">
                (3) To use my name in connection therewith if he/she so chooses.
              </p>
              <p className="text-gray-600">
                I hereby release and discharge the Photographer/Cameraman,
                his/her heirs, executors, assigns and any designee (including
                any agency, client, broadcaster, periodical or other
                publication) from any and all claims and demands arising out of
                or in connection with the use of such photographs, film, or
                tape, including but not limited to any claims for defamation or
                invasion or privacy.
              </p>
              <p className="text-gray-600">
                I am of legal age and have read the foregoing and fully
                understand the contents thereof.
              </p>
            </section>
          </div>

          {/* Fixed Footer */}
        </div>
      </div>
      <div className="bg-gray-50 border-t border-gray-200 px-8 py-4">
        <form
          method="POST"
          onSubmit={handleSelect}
          className="flex items-center justify-between"
        >
          <div className="flex items-center">
            <input
              className="mr-2"
              type="checkbox"
              id="disclaimer"
              name="disclaimer"
              checked={disclaimerChecked}
              onChange={(e) => setDisclaimerChecked(e.target.checked)}
              required
            />
            <label htmlFor="disclaimer" className="text-gray-700">
              I accept the terms and conditions
            </label>
          </div>
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors"
          >
            Next
          </button>
        </form>
      </div>
    </>
  );
};

export default Disclaimer;
